'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:OrderRenewCtrl
 * @description
 * # OrderRenewCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('OrderRenewCtrl', function ($scope, api, /**OrderAndRenewPreview*/ orderAndRenewPreview, /**boolean*/ isAdmin) {
		$scope.order = orderAndRenewPreview.order;
		$scope.details = orderAndRenewPreview.details;
		$scope.licenseKey = orderAndRenewPreview.licenseKey;
		$scope.eligiblePromo = orderAndRenewPreview.eligiblePromo;
		$scope.maxReleaseDate = orderAndRenewPreview.maxReleaseDate;
		$scope.billingPeriod = orderAndRenewPreview.billingPeriod;
		$scope.subscription = orderAndRenewPreview.subscription;
		$scope.isAdmin = isAdmin;
	});
